export default __webpack_public_path__ + "static/kacper_pixel-25395dc61a21d437ab28480ab89a8838.png";